module.exports = __webpack_public_path__ + "static/img/slide1_x2.a4c4930.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/original-slides/slide1_x2.jpeg
// module id = iMg/
// module chunks = 1